// extracted by mini-css-extract-plugin
export default {"nonetWrap":"NoNet_nonetWrap__fPH8b"};